import WiresActivityPage from "components/pages/WiresActivityPage";
import { useEffect } from "react";

/**
 * @name CaptureWireActivityDefaultProfileOpen
 * @returns {React.Component}
 * @description 
 */
export default function CaptureWireActivityDefaultProfileOpen(props) {
    useEffect(() => {
        const link = document.querySelector(`[data-point=Utility_User] .custom-accordion-toggle`)
        if(link) link.click();
    });
    return <WiresActivityPage />;
}